import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { Portal } from "../Portal/Portal";
import { colors } from "../../../styles/colors";
const Button = styled.button `
  position: fixed;
  z-index: 100000;
  left: 5px;
  ${({ variant }) => variant.variant === 'back' ? "bottom: 5px;" : "top: 5px;"}

  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 10px;
  ${({ variant }) => variant.variant === 'end' ? "padding-bottom: 13px;" : ""}

  text-transform: uppercase;
  font-weight: 500;
  font-family: 'Inter';
  font-size: 12px;
  color: ${colors.textPrimary};

  background-color: ${colors.surface};
  border-radius: 5px;
  border: 1px solid ${colors.primary};
  ${({ variant }) => variant.variant === 'end' ? `border-bottom: 3px solid ${colors.primary};` : ""}

  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};
  pointer-events: ${({ disabled }) => disabled ? 'none' : 'auto'};
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: ${colors.surfaceVariant};
  }
`;
export const GameButton = ({ children, className, onClick, variant, text, disabled }) => {
    return (_jsx(Portal, { children: _jsxs(Button, Object.assign({ className: className, onClick: onClick, variant: variant, disabled: disabled }, { children: [children, text] })) }));
};
